export default __webpack_public_path__ + "static/national-metric-desktop-0a7385407b99375348a175d987f475fa.svg";